// extracted by mini-css-extract-plugin
export var eyebrow = "_kh-3";
export var heroImage = "_kh-4";
export var main = "_kh-2";
export var modal = "_kh-0";
export var shell = "_kh-1";